import React from "react";
import HeaderInner from "../header/HeaderInner";
import ProjectMesonary from "./breadcrumb/ProjectMesonary";
import Footer from "../elements/Footer";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";

// DATA
import { DataProject } from "../data/DataProject";
import { DataNav } from "../data/DataNav";

function PortfolioSix() {
  const dataProject = DataProject;

  const dataBreadcrumb = DataNav[3];

  return (
    <div>
      <HeaderInner />
      <>
        <Breadcrumb props={dataBreadcrumb} />
        {/* rmp portfolio mesonary area */}
        <div className="tmp-portfolio-area tmp-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-head">
                  <div className="section-sub-title center-title">
                    <img
                      src="assets/images/services/section-custom-menubar.png "
                      alt="Business_Consulting_services"
                    />
                    <span>{dataProject?.title}</span>
                  </div>
                  <h2 className="title split-collab">
                    {dataProject?.subTitle}
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey={`${dataProject?.dataService?.item0}`}
              >
                <Row>
                  <Col sm={12}>
                    {/* <Nav
                      variant="pills"
                      className="flex-column tmp-mesonary-area-main main-isotop"
                    >
                      <Nav.Item className="tmp-button-group mb--50 filters-button-group">
                        <Nav.Link
                          className="button"
                          eventKey={`${dataProject?.dataService?.item0}`}
                        >
                          {" "}
                          Tous Les Départements
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item className="tmp-button-group mb--50 filters-button-group">
                        <Nav.Link
                          className="button"
                          eventKey={`${dataProject?.dataService?.item1?.id}`}
                        >
                          {dataProject?.dataService?.item1?.title}
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item className="tmp-button-group mb--50 filters-button-group">
                        <Nav.Link
                          className="button"
                          eventKey={`${dataProject?.dataService?.item2?.id}`}
                        >
                          {dataProject?.dataService?.item2?.title}
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item className="tmp-button-group mb--50 filters-button-group">
                        <Nav.Link
                          className="button"
                          eventKey={`${dataProject?.dataService?.item3?.id}`}
                        >
                          {dataProject?.dataService?.item3?.title}
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item className="tmp-button-group mb--50 filters-button-group">
                        <Nav.Link
                          className="button"
                          eventKey={`${dataProject?.dataService?.item4?.id}`}
                        >
                          {dataProject?.dataService?.item4?.title}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav> */}
                  </Col>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey={`${dataProject?.dataService?.item0}`}>
                        <div className="row g-5">
                          {dataProject?.items?.map((item) => {
                            return (
                              <div
                                key={item.id}
                                className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6"
                              >
                                {/* single portfolio-item */}
                                <div className="tmp-single-portfolio-item">
                                  <Link
                                    to={`/detail_realisation_${item.id}`}
                                    className="thumbnail"
                                  >
                                    <img
                                      style={{
                                        width: "410px",
                                        height: "430px",
                                      }}
                                      src={item.img}
                                      alt={item.title}
                                    />
                                  </Link>
                                  <div className="tmp-inner-content">
                                    {/* <div className="top-item">
                                      <span className="left">
                                        Mobile App Design
                                      </span>
                                      <span className="left">25 likes</span>
                                    </div> */}
                                    <Link to={`/detail_realisation_${item.id}`}>
                                      <h2 className="title">{item.title}</h2>
                                    </Link>
                                  </div>
                                </div>
                                {/* single portfolio-item end */}
                              </div>
                            );
                          })}
                        </div>
                      </Tab.Pane>

                      <Tab.Pane
                        eventKey={`${dataProject?.dataService?.item1?.id}`}
                      >
                        <div className="row g-5">
                          {dataProject?.items?.map((item) => {
                            if (
                              item.type === dataProject?.dataService?.item1?.id
                            ) {
                              return (
                                <div
                                  key={item.id}
                                  className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6"
                                >
                                  {/* single portfolio-item */}
                                  <div className="tmp-single-portfolio-item">
                                    <Link
                                      to={`/detail_realisation_${item.id}`}
                                      className="thumbnail"
                                    >
                                      <img
                                        style={{
                                          width: "410px",
                                          height: "430px",
                                        }}
                                        src={item.img}
                                        alt={item.title}
                                      />
                                    </Link>
                                    <div className="tmp-inner-content">
                                      {/* <div className="top-item">
                                            <span className="left">
                                              Mobile App Design
                                            </span>
                                            <span className="left">25 likes</span>
                                          </div> */}
                                      <Link
                                        to={`/detail_realisation_${item.id}`}
                                      >
                                        <h2 className="title">{item.title}</h2>
                                      </Link>
                                    </div>
                                  </div>
                                  {/* single portfolio-item end */}
                                </div>
                              );
                            }
                          })}
                        </div>
                      </Tab.Pane>

                      <Tab.Pane
                        eventKey={`${dataProject?.dataService?.item2?.id}`}
                      >
                        <div className="row g-5">
                          {dataProject?.items?.map((item) => {
                            if (
                              item.type === dataProject?.dataService?.item2?.id
                            ) {
                              return (
                                <div
                                  key={item.id}
                                  className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6"
                                >
                                  {/* single portfolio-item */}
                                  <div className="tmp-single-portfolio-item">
                                    <Link
                                      to={`/detail_realisation_${item.id}`}
                                      className="thumbnail"
                                    >
                                      <img
                                        style={{
                                          width: "410px",
                                          height: "430px",
                                        }}
                                        src={item.img}
                                        alt={item.title}
                                      />
                                    </Link>
                                    <div className="tmp-inner-content">
                                      {/* <div className="top-item">
                                            <span className="left">
                                              Mobile App Design
                                            </span>
                                            <span className="left">25 likes</span>
                                          </div> */}
                                      <Link
                                        to={`/detail_realisation_${item.id}`}
                                      >
                                        <h2 className="title">{item.title}</h2>
                                      </Link>
                                    </div>
                                  </div>
                                  {/* single portfolio-item end */}
                                </div>
                              );
                            }
                          })}
                        </div>
                      </Tab.Pane>

                      <Tab.Pane
                        eventKey={`${dataProject?.dataService?.item3?.id}`}
                      >
                        <div className="row g-5">
                          {dataProject?.items?.map((item) => {
                            if (
                              item.type === dataProject?.dataService?.item3?.id
                            ) {
                              return (
                                <div
                                  key={item.id}
                                  className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6"
                                >
                                  {/* single portfolio-item */}
                                  <div className="tmp-single-portfolio-item">
                                    <Link
                                      to={`/detail_realisation_${item.id}`}
                                      className="thumbnail"
                                    >
                                      <img
                                        style={{
                                          width: "410px",
                                          height: "430px",
                                        }}
                                        src={item.img}
                                        alt={item.title}
                                      />
                                    </Link>
                                    <div className="tmp-inner-content">
                                      {/* <div className="top-item">
                                            <span className="left">
                                              Mobile App Design
                                            </span>
                                            <span className="left">25 likes</span>
                                          </div> */}
                                      <Link
                                        to={`/detail_realisation_${item.id}`}
                                      >
                                        <h2 className="title">{item.title}</h2>
                                      </Link>
                                    </div>
                                  </div>
                                  {/* single portfolio-item end */}
                                </div>
                              );
                            }
                          })}
                        </div>
                      </Tab.Pane>

                      <Tab.Pane
                        eventKey={`${dataProject?.dataService?.item4?.id}`}
                      >
                        <div className="row g-5">
                          {dataProject?.items?.map((item) => {
                            if (
                              item.type === dataProject?.dataService?.item4?.id
                            ) {
                              return (
                                <div
                                  key={item.id}
                                  className="flash grid-item-p element-item transition creative col-lg-4 col-md-6 col-sm-6"
                                >
                                  {/* single portfolio-item */}
                                  <div className="tmp-single-portfolio-item">
                                    <Link
                                      to={`/detail_realisation_${item.id}`}
                                      className="thumbnail"
                                    >
                                      <img
                                        style={{
                                          width: "410px",
                                          height: "430px",
                                        }}
                                        src={item.img}
                                        alt={item.title}
                                      />
                                    </Link>
                                    <div className="tmp-inner-content">
                                      {/* <div className="top-item">
                                            <span className="left">
                                              Mobile App Design
                                            </span>
                                            <span className="left">25 likes</span>
                                          </div> */}
                                      <Link
                                        to={`/detail_realisation_${item.id}`}
                                      >
                                        <h2 className="title">{item.title}</h2>
                                      </Link>
                                    </div>
                                  </div>
                                  {/* single portfolio-item end */}
                                </div>
                              );
                            }
                          })}
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        </div>
        {/* rmp portfolio mesonary area end */}
        <Footer />
      </>
    </div>
  );
}

export default PortfolioSix;
